if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',
    class ShopTheLook extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-shop-look-form]');
        this.status = this.querySelector('[data-shop-look-status]');
        this.submitButton = this.querySelector('[data-shop-look-submit]');

        this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      }

      async onSubmit(event) {
        event.preventDefault();

        const selectedItems = Array.from(this.querySelectorAll('[data-look-product]:checked'))
          .map((checkbox) => {
            const row = checkbox.closest('[data-look-row]');
            const select = row?.querySelector('[data-look-variant]');

            return {
              id: Number(select?.value),
              quantity: 1,
            };
          })
          .filter((item) => item.id);

        if (!selectedItems.length) {
          this.setStatus('Choose at least one item to add.');
          return;
        }

        this.submitButton?.setAttribute('disabled', 'disabled');
        this.setStatus('Adding selected pieces...');

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items: selectedItems }),
          });

          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || 'Could not add selected pieces.');
          }

          this.setStatus('Added to cart.');
          window.location.href = window.routes?.cart_url || '/cart';
        } catch (error) {
          this.setStatus(error.message || 'Something went wrong. Please try again.');
          this.submitButton?.removeAttribute('disabled');
        }
      }

      setStatus(message) {
        if (this.status) this.status.textContent = message;
      }
    },
  );
}
